import { render, staticRenderFns } from "./UnitLosList.vue?vue&type=template&id=0704c151&scoped=true&"
import script from "./UnitLosList.vue?vue&type=script&lang=js&"
export * from "./UnitLosList.vue?vue&type=script&lang=js&"
import style0 from "./UnitLosList.vue?vue&type=style&index=0&id=0704c151&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0704c151",
  null
  
)

export default component.exports